/**
 * i18n resources for the `analytics` feature slice (dashboard analytics:
 * calls handled, bookings, average handling time, languages).
 *
 * Shape: `{ namespace, resources: { en, bg, de, fr } }`. Non-English locales
 * start as English placeholders so key-parity passes (master prompt §13).
 */

export const namespace = 'analytics' as const;

const en = {
  page: {
    eyebrow: 'Intelligence',
    title: 'Analytics',
    description: 'A calm overview of how the front desk is performing.',
  },
  metrics: {
    callsHandled: { label: 'Calls handled', help: 'Calls answered by the assistant.' },
    bookings: { label: 'Bookings', help: 'Reservation drafts created from calls.' },
    aht: { label: 'Avg. handling time', help: 'Average call duration.' },
    languages: { label: 'Languages', help: 'Distinct guest languages detected.' },
  },
  trend: {
    title: 'Calls over time',
    description: 'Daily call volume across the selected period.',
    calls: 'Calls',
    bookings: 'Bookings',
  },
  empty: {
    title: 'No analytics yet',
    description: 'Metrics populate here as the assistant handles calls and bookings.',
  },
  states: {
    noData: 'No data',
    loading: 'Loading analytics…',
    errorTitle: 'Could not load analytics',
    errorDescription: 'Something went wrong loading analytics. Please try again.',
  },
  noAccess: {
    title: 'No access',
    description: 'You do not have permission to view analytics for this hotel.',
  },
} as const;

export const resources = {
  en: { [namespace]: en },
  bg: { [namespace]: en },
  de: { [namespace]: en },
  fr: { [namespace]: en },
} as const;
